import moment from "moment"
import { getCurrencySymbol } from "../constants";
export const modifyDate = (orderDate) => {
    const year = new Date(orderDate).getFullYear();
    return year !== 1 ? moment(orderDate).format("DD-MM-YYYY HH:mm:ss") : "";
  };
  export const setPrice = (price) => {
    const currency = getCurrencySymbol()
    if(price == 0){
      return `${currency + price}.00`
    }else if(typeof price === "number"){
      return price && currency + setNumberPrecision(price);
    }else{
      return currency + price
    }
    
  };
  
  export const setNumberPrecision = (val) => {
    return !!val && val?.toFixed(2);
  };
  const formatDecimals = (num) => {
    const calcDec = Math.pow(10, 1);
    return Math.trunc(num * calcDec) / calcDec;
  }

  export const formattedDate = (timestamp) => `${new Date(timestamp).toLocaleString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric', 
      hour: 'numeric', 
      minute: 'numeric', 
      hour12: true 
  })}`;

  const checkFloatingValue = (formattedData) => {
    return Number.isInteger(formattedData) ? formattedData : formatDecimals(formattedData)
  }

  export const checkDataSize = (dataSizeInBytes) => {
    const bytesInOneMB = 1000 * 1000; // 1 MB = 1024 KB, 1 KB = 1024 bytes
    const bytesInOneGB = bytesInOneMB * 1000; // 1 GB = 1024 MB
    if (dataSizeInBytes >= bytesInOneGB) {
      // Data is in GB
      const dataSizeInGB = dataSizeInBytes / bytesInOneGB;
      return checkFloatingValue(dataSizeInGB) + " GB";
    } else if (dataSizeInBytes >= bytesInOneMB) {
      // Data is in MB
      const dataSizeInMB = dataSizeInBytes / bytesInOneMB;
      return checkFloatingValue(dataSizeInMB) + " MB";
    } else if(dataSizeInBytes >= 1000) {
      // Data is in bytes
      const dataSizeInMB = dataSizeInBytes / 1000;
      return checkFloatingValue(dataSizeInMB) + " KB";
    } else {
      return 0 + " KB"
    }
  };

  export const displayBase64 = (image)=>"data:image/png;base64,"+image


  export const customInput = ({events, props}) => {
    return <>
        <input {...events} {...props} type="text" autoComplete="off" />
    </>
};

  export const filterCountryName = (country) => {
    return country ? country.split(" (")[0] : "";
  };

  export const setDataAmount = (rowData) => {
    if (rowData?.dataAmount !== undefined) {
      return rowData.dataAmount === -1
        ? rowData.dataAmountForDisplay
        : `${rowData.dataAmount / 1000000000} GB`;
    }
    return "-";
  };

  export const formatPromoCode = (promoCode, isVoucherCode = true) => {
    if (!promoCode) {
      return '-';
    }
    return isVoucherCode
      ? promoCode.toUpperCase().match(/.{1,4}/g).join('-')
      : promoCode;
  };

  export const serializeParams = (params) => {
    return Object.keys(params)
        .filter(key => {
            const value = params[key];
            return value !== null && value !== undefined && value !== '' && (!Array.isArray(value) || value.length > 0);
        })
        .map(key => {
            const value = params[key];
            if (Array.isArray(value)) {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`;
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .join('&');
  };

  export const getCurrentTimestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}-${hours}${minutes}${seconds}`;
  };


export const PERMISSIONS = {
  SEE_ORDERS: 1,        // 0b00001
  LIST_VOUCHERS: 2,     // 0b00010
  MODIFY_VOUCHERS: 4,   // 0b00100
  CREATE_VOUCHERS: 8,   // 0b01000
  SEE_USERS: 16         // 0b10000
};

// Combined masks for convenience
export const VOUCHER_MANAGEMENT_MASK = 
  PERMISSIONS.LIST_VOUCHERS | 
  PERMISSIONS.MODIFY_VOUCHERS | 
  PERMISSIONS.CREATE_VOUCHERS; // 14

export const MODIFY_VOUCHER_MASK = 
  PERMISSIONS.MODIFY_VOUCHERS | 
  PERMISSIONS.CREATE_VOUCHERS; // 12

// Checks if ALL bits in permissionToCheck are present in userPermission
export const hasPermission = (userPermission, permissionToCheck) => {
  return (userPermission & permissionToCheck) === permissionToCheck;
};

// Checks if ANY bit in permissionMask is present in userPermission
export const hasAnyPermission = (userPermission, permissionMask) => {
  return (userPermission & permissionMask) !== 0;
};